import { http } from "../../core/utils/http";
import authHeader from "../../core/utils/auth.header.js";
import axios, { Axios } from "axios";
import { Create, Transfer } from "./interface/wallet.interface";
import authhHeader from "../../core/utils/authh.header";

class WalletService {
  constructor(private readonly request: Axios) {}

  private createAxiosInstance() {
    return axios.create({
      baseURL: import.meta.env.VITE_SECOND_BASE_URL, 
      headers: authhHeader(), 
    });
  }

async getWallet(userId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
      .get(`/Wallet/fetch/${userId}`)
      .then((res) => {
          console.log("Wallet fetched successfully:", res);
          return res;
      })
      .catch((err) => {
          console.error("Error fetching wallet:", err.response ? err.response.data : err.message);
          throw err; 
      });
}

  async getTransactionHistory(organisationId: number, year: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .get('/Transaction/history', {
        params: { OrganisationId: organisationId, Year: year },
      })
      .then((res) => res)
      .catch((err) => err);
  }

  async getChartData(year:any): Promise<any> {
    return await this.request
      .get("/dashboard?chart="+year, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getChartYears(): Promise<any> {
    return await this.request
      .get("/dashboard", {
        headers: authHeader(),
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
  async transfer(data: Transfer): Promise<any> {
    return await this.request
      .post(
        "/wallet/transfer",
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getBanks(): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
        .get("/Providus/get-banks", {
            headers: authHeader(),
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            return err;
        });
  }
  
  async getWalletHistory(): Promise<any> {
    return await this.request
      .get("/wallet/transactions", {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async createWallet(userId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
        .post(`/Wallet/create/${userId}`)
        .then((res) => {
            console.log("Wallet created successfully:", res);
            return res;
        })
        .catch((err) => {
            console.error("Error creating wallet:", err);
            throw err; 
        });
  }
}

export default new WalletService(http);
